"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const formik_1 = require("formik");
const nmr_processing_1 = require("nmr-processing");
const react_2 = require("react");
const fa_1 = require("react-icons/fa");
const Yup = __importStar(require("yup"));
const Button_1 = __importDefault(require("../../../../elements/Button"));
const FormikInput_1 = __importDefault(require("../../../../elements/formik/FormikInput"));
const formatNumber_1 = require("../../../../utility/formatNumber");
const styles = {
    container: (0, react_1.css) `
    text-align: center;
    width: 100%;
    height: 100%;
    padding: 0.4rem;
  `,
    inputInfo: (0, react_1.css) `
    font-size: 10px;
    color: black;
    font-weight: bold;
  `,
    infoText: (0, react_1.css) `
    padding: 10px;
    font-size: 13px;
  `,
    signalContainer: (0, react_1.css) `
    border: 0.55px solid #dedede;
  `,
    inputContainer: (0, react_1.css) `
    display: flex;
    justify-content: center;
  `,
};
// TODO: this seems to be a hacky use of ref.
function AddSignalFormTab({ onFocus, onBlur, range, preferences }, ref) {
    const { values, setFieldValue } = (0, formik_1.useFormikContext)();
    const saveHandler = (0, react_2.useCallback)((val) => {
        const newSignal = {
            multiplicity: 'm',
            kind: 'signal',
            delta: Number(val.newSignalDelta),
            js: [{ multiplicity: (0, nmr_processing_1.translateMultiplet)('m'), coupling: '' }],
        };
        const _signals = values.signals.slice().concat(newSignal);
        void setFieldValue('signals', _signals);
        void setFieldValue('activeTab', String(_signals.length - 1));
    }, [setFieldValue, values.signals]);
    const validation = (0, react_2.useMemo)(() => {
        return Yup.object().shape({
            newSignalDelta: Yup.number()
                .test(`test-range`, '', function testNewSignalDelta(value) {
                const { path, createError } = this;
                if (value && value > range.from && value < range.to) {
                    return true;
                }
                const errorMessage = ` ${value ? value.toFixed(5) : 0} ppm out of the range`;
                return createError({ path, message: errorMessage });
            })
                .required(),
        });
    }, [range]);
    const triggerSubmitHandler = (0, react_2.useCallback)(() => {
        ref.current.submitForm();
    }, [ref]);
    return ((0, jsx_runtime_1.jsx)("div", { css: styles.container, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { css: styles.infoText, children: "Edit or select a delta value of new signal (ppm):" }), (0, jsx_runtime_1.jsx)(formik_1.Formik, { innerRef: ref, validationSchema: validation, initialValues: {
                        newSignalDelta: (range.from + range.to) / 2,
                    }, onSubmit: saveHandler, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { css: styles.inputContainer, children: [(0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "newSignalDelta", type: "number", placeholder: `𝛅 (ppm)`, onFocus: onFocus, onBlur: onBlur, style: {
                                            input: {
                                                width: '250px',
                                                height: '30px',
                                            },
                                        }, checkErrorAfterInputTouched: false }), (0, jsx_runtime_1.jsx)(Button_1.default.Done, { style: {
                                            marginLeft: '5px',
                                            height: '30px',
                                        }, onClick: triggerSubmitHandler, children: (0, jsx_runtime_1.jsx)(fa_1.FaPlus, { title: "Add new signal" }) })] }), (0, jsx_runtime_1.jsxs)("p", { css: styles.inputInfo, children: ["[", `${(0, formatNumber_1.formatNumber)(range.from, preferences.from.format)} ppm - ${(0, formatNumber_1.formatNumber)(range.to, preferences.to.format)} ppm`, "]"] })] }) })] }) }));
}
exports.default = (0, react_2.forwardRef)(AddSignalFormTab);
